export default {
  formField: {
    optional: "اختياري",
  },
  datePicker: {
    placeholder: "يوم/شهر/سنة",
    openCalendar: "افتح التقويم",
    closeCalendar: "أغلق التقويم",
  },
  comboBox: {
    noResults: "لا توجد نتائج",
    clearSelection: "مسح الاختيار",
  },
  input: {
    clearField: "مسح الحقل",
  },
  select: {
    noResults: "لا توجد نتائج",
    clearSelection: "مسح الاختيار",
  },
  emptyState: {
    illustrationAlt: "رسم توضيحي بدون بيانات",
  },
  avatar: {
    imageAlt: "الصورة الرمزية",
  },
  avatarStack: {
    loadingAriaLabel: "جاري تحميل مجموعة الصور الرمزية",
    groupAriaLabel: "مجموعة صور رمزية تضم {{count}} أشخاص: {{names}}",
    overflowAriaLabel: "{{count}} أشخاص إضافيين: {{names}}",
    overflowAriaLabelNoNames: "{{count}} أشخاص إضافيين",
  },
  tag: {
    remove: "إزالة",
  },
  pagination: {
    show: "عرض",
    pagination: "ترقيم الصفحات",
    goToPrevPage: "الانتقال إلى الصفحة السابقة",
    goToNextPage: "الانتقال إلى الصفحة التالية",
    goToPage: "الانتقال إلى صفحة {{pageNumber}}",
    itemsPerPage: "عناصر في الصفحة",
    itemsRange: "{{from}}-{{to}} من {{total}}",
    ellipsis: "...",
  },
  tabs: {
    moreTabs: "المزيد من علامات التبويب",
  },
  table: {
    selectionSummary: "تم تحديد {{count}} من {{total}} صف",
    selectionSummaryAll: "تم تحديد جميع {{total}} صف",
    selectAllButton: "تحديد جميع {{total}} صف",
    selectAllItemsOnPageAriaLabel: "تحديد جميع العناصر في الصفحة الحالية",
    selectRowAriaLabel: "تحديد الصف",
    dataTableAriaLabel: "جدول البيانات",
    clickableRowAriaLabel: "صف قابل للنقر، اضغط Enter أو مسافة للتحديد",
    sortColumnAriaLabel: "ترتيب حسب {{column}}",
    sortColumnAscAriaLabel:
      "ترتيب حسب {{column}} تصاعدي، اضغط Enter أو مسافة للترتيب تنازلياً",
    sortColumnDescAriaLabel:
      "ترتيب حسب {{column}} تنازلي، اضغط Enter أو مسافة لإلغاء الترتيب",
  },
  columnsSelect: {
    selectColumns: "اختر الأعمدة",
  },
  drawer: {
    closeLabel: "إغلاق",
  },
  panel: {
    closeLabel: "إغلاق",
  },
  modal: {
    closeLabel: "إغلاق",
  },
  toast: {
    closeNotification: "إغلاق الإشعار",
  },
  copyButton: {
    copy: "نسخ",
    copied: "تم النسخ",
  },
  confirmDialog: {
    cancel: "إلغاء",
  },
  codeInput: {
    inputGroupAriaLabel: "رمز التحقق, {{length}} أرقام",
    digitInputAriaLabel: "رقم {{index}} من {{length}}",
  },
  splitButton: {
    openMenu: "افتح القائمة",
  },
  stepper: {
    progress: "التقدم",
    stepAriaLabel: "الخطوة {{stepNumber}}: {{stepTitle}}",
  },
};
